'use client';

import { useState } from 'react';

import { PersonalDetail } from 'components/atomic/atoms';
import { UserProfileLayout } from 'components/atomic/molecules';
import {
  HeaderOrganism,
  MobileNavbarOrganism
} from 'components/atomic/organism';
import { useIsMobile } from 'helpers/screenResolutionHelper';

export default function UserProfile() {
  const [isMobile] = useIsMobile();
  const [showSearchModal, setShowSearchModal] = useState(false);
  const [savedName, setSavedName] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  return (
    <>
      {!showSearchModal && <HeaderOrganism heading='Profile' />}
      <UserProfileLayout
        isLoading={isLoading}
        myProfile={true}
        showSideNav={true}
        name={savedName}
      >
        <PersonalDetail
          hidePersonalDetail={true}
          savedName={savedName}
          setSavedName={setSavedName}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
        />
        {isMobile ? (
          <MobileNavbarOrganism
            onPage={'user-profile'}
            showSearchModal={showSearchModal}
            setShowSearchModal={setShowSearchModal}
          />
        ) : (
          ''
        )}
      </UserProfileLayout>
    </>
  );
}
